import React from 'react';
import './WhatHaveCount.css'

const WhatHaveCount = () => {
    return (
        <div data-aos="zoom-in-up" className="counter-up">
            <div className="content">
                <div className="box">
          <div className="icon">
          <i className="fa fa-users"></i>
          </div>
          <div className="counter">
             200
          </div>
          <div className='text'>
             Trainees
          </div>
                </div>
                <div className="box">
          <div className="icon">
          <i className="fa fa-user-tie"></i>
          </div>
          <div className="counter">
             25
          </div>
          <div className='text'>
          Entrepreneurs
          </div>
                </div>
                <div className="box">
          <div className="icon">
          <i class="fas fa-briefcase"></i>
          </div>
          <div className="counter">
          500
          </div>
          <div className='text'>
          Beneficiaries
          </div>
                </div>
                <div className="box">
          <div className="icon">
          <i class="fas fa-dollar-sign"></i>
          </div>
          <div className="counter">
          1,000,000
          </div>
          <div className='text'>
          Investment
          </div>
                </div>
                <div className="box">
          <div className="icon">
          <i class="fas fa-hands-helping"></i>
          </div>
          <div className="counter">
             25
          </div>
          <div className='text'>
          Partnership
          </div>
                </div>
                <div className="box">
          <div className="icon">
          <i className="fa fa-chalkboard-teacher"></i>
          </div>
          <div className="counter">
             10
          </div>
          <div className='text'>
            Mentor
          </div>
                </div>
                <div className="box">
          <div className="icon">
          <i class="fas fa-id-card-alt"></i>
          </div>
          <div className="counter">
             3
          </div>
          <div className='text'>
          Interns
          </div>
                </div>
                <div className="box">
          <div className="icon">
          <i class="fas fa-people-carry"></i>
          </div>
          <div className="counter">
             3
          </div>
          <div className='text'>
          Volunteers
          </div>
                </div>

            </div>
            
        </div>
    );
};

export default WhatHaveCount;